<template>
  <div class="content-edit-page">
    <div class="zhanwei4"></div>

    <!-- 顶部操作导航栏 -->
    <div class="action-topbar-card">
      <div class="bar-left">
        <div class="icon-avatar">
          <el-icon><Guide /></el-icon>
        </div>
        <div class="text-group">
          <h2 class="title">
            {{ $t("Content.contentEdit") || "关卡编排与全局地图配置" }}
          </h2>
          <span class="sub-text"
            >拖拽关卡卡片可快速调整玩家闯关顺序，右侧可配置地图类型与初始坐标</span
          >
        </div>
      </div>

      <div class="bar-right">
        <div class="map-type-select">
          <span class="select-label">地图底图引擎</span>
          <el-select
            v-model="value"
            placeholder="选择地图类型"
            class="map-select-box"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>

        <el-button
          type="primary"
          class="save-btn"
          @click="value === '自定义地图' ? saveContent() : saveContent2()"
        >
          <el-icon><DocumentChecked /></el-icon>
          {{ $t("Content.save") || "保存配置" }}
        </el-button>
      </div>
    </div>

    <!-- 双栏工作台排版 -->
    <div class="workbench-layout">
      <el-row :gutter="24">
        <!-- 左侧：关卡排序与新增展台 -->
        <el-col :xs="24" :lg="10">
          <div class="level-list-panel">
            <div class="panel-header">
              <div class="panel-title-box">
                <span class="panel-title">关卡列表</span>
                <span class="level-count-badge">共 {{ list2.length }} 关</span>
              </div>
              <el-button
                type="primary"
                class="add-level-btn"
                :icon="Plus"
                @click="addLevel"
              >
                {{ $t("Content.addLevel") || "新建关卡" }}
              </el-button>
            </div>

            <!-- 可拖拽列表 -->
            <div
              class="draggable-list-container"
              v-draggable="[
                list2,
                {
                  animation: 150,
                  onUpdate,
                  onStart,
                  handle: '.drag-handle',
                },
              ]"
            >
              <div
                class="level-item-card"
                v-for="(item, index) in list2"
                :key="item.levelId || item.id"
              >
                <div class="drag-handle" title="按住拖拽排序">
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </div>

                <div class="level-badge">{{ index + 1 }}</div>

                <div class="level-info" @click="toEditLevel(item.levelId)">
                  <span class="level-name">{{
                    item.name || `关卡 ${index + 1}`
                  }}</span>
                  <span class="level-hint">点击进入详细关卡谜题配置</span>
                </div>

                <div class="action-icons">
                  <el-tooltip content="编辑关卡" placement="top">
                    <button
                      class="icon-btn edit-btn"
                      @click.stop="toEditLevel(item.levelId)"
                    >
                      <el-icon><EditPen /></el-icon>
                    </button>
                  </el-tooltip>
                  <el-tooltip content="删除关卡" placement="top">
                    <button
                      class="icon-btn del-btn"
                      @click.stop="deleteLevel(item.levelId)"
                    >
                      <el-icon><DeleteFilled /></el-icon>
                    </button>
                  </el-tooltip>
                </div>
              </div>

              <div v-if="list2.length === 0" class="empty-level-box">
                <el-icon class="empty-icon"><InfoFilled /></el-icon>
                <p>暂无配置关卡，请点击上方按钮新建</p>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 右侧：地图探索容器 -->
        <el-col :xs="24" :lg="14">
          <div class="map-preview-panel">
            <div class="map-panel-header">
              <span class="map-status-dot"></span>
              <span class="map-title-txt"
                >{{ value }} · 坐标拾取与路线标记</span
              >
            </div>

            <div class="map-viewport-card">
              <div v-if="value === '高德地图'" class="map-container-wrap">
                <MapContainer
                  @changePos="changePos"
                  :long="long"
                  :lat="lat"
                ></MapContainer>
              </div>
              <div v-if="value === '自定义地图'" class="custom-canvas-wrap">
                <Cavan ref="Cav" :imgUrl="CavImg"></Cavan>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="zhanwei4"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import {
  DeleteFilled,
  EditPen,
  Plus,
  Guide,
  DocumentChecked,
  InfoFilled,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { vDraggable } from "vue-draggable-plus";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { toRaw } from "@vue/reactivity";
import MapContainer from "@/components/content/MapContainer.vue";
import Cavan from "@/components/canvans/canvans.vue";

export default defineComponent({
  name: "ContentEditModule",
  directives: {
    draggable: vDraggable,
  },
  components: {
    EditPen,
    DeleteFilled,
    MapContainer,
    Cavan,
    Guide,
    DocumentChecked,
    InfoFilled,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const instance = getCurrentInstance();

    const list2 = ref(store.state.game.levels || []);
    const gameLevelId = ref("");
    const long = ref(0);
    const lat = ref(0);
    const value = ref("自定义地图");
    const CavImg = ref("");

    const options = ref([
      { value: "高德地图", label: "高德地图" },
      { value: "自定义地图", label: "自定义手绘地图" },
    ]);

    const gameId = route.params.id as string;

    onMounted(() => {
      if (gameId && gameId !== "0") {
        const game = store.state.game.games.find(
          (item: any) => item.id == gameId
        );
        if (game) {
          gameLevelId.value = game.gameLevelId;
          long.value = game.longitude;
          lat.value = game.latitude;
          if (game.mapSelect) {
            value.value = game.mapSelect;
          }
          CavImg.value = game.customizeMap || "";

          if (game.mapSelect === "自定义地图" && game.customizeMap) {
            const canvans: any = instance?.proxy?.$refs["Cav"];
            if (canvans) {
              canvans.customeMap2(game.customizeMap);
            }
          }
        }
      }
    });

    function onStart() {}

    async function onUpdate() {
      const items = toRaw(list2.value);
      const sortLevel = items.map((item: any) => item.levelId).join(",");

      try {
        await store.dispatch("game/setGameSort", {
          gameLevelId: gameLevelId.value,
          sortLevel,
        });
        ElMessage.success("关卡排序已同步更新");
      } catch (error) {
        ElMessage.error("排序保存失败，请重试");
      }
    }

    function toEditLevel(levelId: string) {
      if (levelId) {
        router.push(`/edit/${gameId}/${levelId}`);
      }
    }

    function deleteLevel(levelId: string) {
      ElMessageBox.confirm(
        "确定要删除该关卡及其关联谜题吗？此操作不可逆。",
        "删除警告",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "取消",
          draggable: true,
          type: "warning",
        }
      )
        .then(() => {
          store
            .dispatch("game/delLevel", {
              ids: [levelId],
              gameLevelId: gameLevelId.value,
              gameId: gameId,
            })
            .then((res: any) => {
              if (res === 1) {
                list2.value = list2.value.filter(
                  (item: any) => item.levelId !== levelId
                );
                ElMessage.success("关卡删除成功");
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    }

    function addLevel() {
      const nextIndex = list2.value.length + 1;
      const title = `关卡${nextIndex}`;

      store
        .dispatch("game/add2Level", {
          levelTitle: title,
          gameLevelId: gameLevelId.value,
          gameId: gameId,
        })
        .then((res: any) => {
          if (res) {
            list2.value.push({
              id: nextIndex,
              levelId: res.id,
              name: res.levelTitle,
            });
            ElMessage.success("新关卡已添加");
          }
        })
        .catch(() => {});
    }

    function changePos(value1: number, value2: number) {
      store
        .dispatch("game/UpdateGamePos", {
          gameId: gameId,
          value1: value1,
          value2: value2,
        })
        .then(() => {})
        .catch(() => {});
    }

    const saveContent = () => {
      const canvans: any = instance?.proxy?.$refs["Cav"];
      if (canvans) {
        canvans.saveImage(gameId);
      }
    };

    const saveContent2 = () => {
      const game = store.state.game.games.find(
        (item: any) => item.id == gameId
      );
      if (game && game.mapSelect !== "高德地图") {
        store
          .dispatch("game/UpdateGameMap", {
            gameId: gameId,
            mapSelect: "高德地图",
          })
          .then(() => {
            ElMessage.success("已切换为高德地图");
          });
      }
    };

    return {
      list2,
      onStart,
      onUpdate,
      gameLevelId,
      gameId,
      long,
      lat,
      toEditLevel,
      deleteLevel,
      addLevel,
      changePos,
      value,
      options,
      saveContent,
      saveContent2,
      CavImg,
      Plus,
    };
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.zhanwei4 {
  height: 20px;
}

.content-edit-page {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 顶部操作卡片
.action-topbar-card {
  background: #ffffff;
  border: 1px solid @card-border;
  border-radius: 14px;
  padding: 18px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.03);
  margin-bottom: 24px;

  .bar-left {
    display: flex;
    align-items: center;
    gap: 14px;

    .icon-avatar {
      width: 42px;
      height: 42px;
      border-radius: 10px;
      background: @primary-light;
      color: @primary-color;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      flex-shrink: 0;
    }

    .text-group {
      .title {
        margin: 0 0 4px 0;
        font-size: 17px;
        font-weight: 700;
        color: @text-main;
      }
      .sub-text {
        font-size: 12.5px;
        color: @text-muted;
      }
    }
  }

  .bar-right {
    display: flex;
    align-items: center;
    gap: 16px;

    .map-type-select {
      display: flex;
      align-items: center;
      gap: 8px;

      .select-label {
        font-size: 13px;
        color: @text-sub;
        font-weight: 500;
        white-space: nowrap;
      }

      .map-select-box {
        width: 160px;
        :deep(.el-input__wrapper) {
          border-radius: 8px;
        }
      }
    }

    .save-btn {
      height: 40px;
      padding: 0 20px;
      border-radius: 8px;
      font-weight: 600;
      background-color: @primary-color;
      border-color: @primary-color;
      box-shadow: 0 3px 10px rgba(93, 95, 239, 0.25);
      transition: all 0.2s ease;

      &:hover {
        background-color: #4b4de0;
        border-color: #4b4de0;
        transform: translateY(-1px);
      }
    }
  }

  @media (max-width: 860px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    .bar-right {
      width: 100%;
      justify-content: space-between;
    }
  }
}

// 工作台双栏
.workbench-layout {
  width: 100%;
}

// 左侧关卡列表面板
.level-list-panel {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid @card-border;
  padding: 24px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .panel-title-box {
      display: flex;
      align-items: center;
      gap: 8px;

      .panel-title {
        font-size: 16px;
        font-weight: 700;
        color: @text-main;
      }

      .level-count-badge {
        font-size: 11.5px;
        font-weight: 600;
        color: @primary-color;
        background: @primary-light;
        padding: 2px 8px;
        border-radius: 12px;
      }
    }

    .add-level-btn {
      border-radius: 8px;
      font-weight: 600;
      background-color: @primary-color;
      border-color: @primary-color;

      &:hover {
        background-color: #4b4de0;
        border-color: #4b4de0;
      }
    }
  }

  .draggable-list-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 200px;
  }

  // 关卡名片
  .level-item-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f8fafc;
    border: 1px solid @border-color;
    border-radius: 12px;
    padding: 12px 14px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: #ffffff;
      border-color: #c7d2fe;
      transform: translateX(4px);
      box-shadow: 0 4px 14px rgba(93, 95, 239, 0.1);
    }

    .drag-handle {
      display: flex;
      flex-direction: column;
      gap: 3px;
      cursor: grab;
      padding: 4px;

      .dot {
        width: 3px;
        height: 3px;
        background: #94a3b8;
        border-radius: 50%;
      }

      &:active {
        cursor: grabbing;
      }
    }

    .level-badge {
      width: 28px;
      height: 28px;
      border-radius: 8px;
      background: @primary-light;
      color: @primary-color;
      font-size: 13px;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
    }

    .level-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .level-name {
        font-size: 14px;
        font-weight: 600;
        color: @text-main;
      }

      .level-hint {
        font-size: 11.5px;
        color: @text-muted;
      }
    }

    .action-icons {
      display: flex;
      align-items: center;
      gap: 6px;

      .icon-btn {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        border: none;
        background: transparent;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        transition: all 0.2s;

        &.edit-btn {
          color: @text-sub;
          &:hover {
            background: @primary-light;
            color: @primary-color;
          }
        }

        &.del-btn {
          color: @text-sub;
          &:hover {
            background: #fee2e2;
            color: @danger-color;
          }
        }
      }
    }
  }

  .empty-level-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: @text-muted;
    gap: 8px;

    .empty-icon {
      font-size: 28px;
    }
  }
}

// 右侧地图面板
.map-preview-panel {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid @card-border;
  padding: 24px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;

  .map-panel-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;

    .map-status-dot {
      width: 8px;
      height: 8px;
      background: #10b981;
      border-radius: 50%;
      box-shadow: 0 0 6px rgba(16, 185, 129, 0.5);
    }

    .map-title-txt {
      font-size: 14px;
      font-weight: 700;
      color: @text-main;
    }
  }

  .map-viewport-card {
    width: 100%;
    height: 560px;
    border-radius: 12px;
    border: 1px solid @border-color;
    overflow: hidden;
    background: #f8fafc;
    position: relative;

    .map-container-wrap,
    .custom-canvas-wrap {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
